module.exports = __webpack_public_path__ + "assets/img/202107-4W.fb65af1a.png";